import * as THREE from 'three';
import { jsondan } from '../../FikoThreeType';
import { FikoSahne } from '../FikoSahne';
import { FikoVektor3D } from '../FikoVektor3d';
import { FikoTakim } from './FikoTakim';
import { FikoTakimFrezeleme } from './FikoTakimFrezeleme';

export class FikoVektorTakimYol3Dv1 extends FikoVektor3D {
    type: any = "FikoVektorTakimYol3Dv1";
    /** */
    takimYonu?: FikoVektor3D = new FikoVektor3D(0, 0, 1);
    hiz?: number;
    devir?: number;
    renk?: THREE.Color;
    hareketTuru?: "YAKLASMA" | "UZAKLASMA" | "BOSTA" | "ISLEME" | "BILINMIYOR"

    takim?: FikoTakim & FikoTakimFrezeleme | any;

    ekBilgiler?: any;
    guncelSure?: number = null;
    toplamSure?: number = null;

    program:any;
    aktivite:any;

    constructor(x?: number, y?: number, z?: number) {
        super(x, y, z);
    }


    toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = {
            type: this.type,
            takimYonu: this.takimYonu.toArray(),
            hiz: this.hiz,
            devir: this.devir,
            renk: this.renk.toArray(),
            takim: { type: this.takim.type, uuid: this.takim.uuid, cap: this.takim.cap, radius: this.takim.radius, boy: this.takim.boy, kesmeBoy: this.takim.kesmeBoy },
            ekBilgiler: { ismi: this.ekBilgiler.ismi, programIsmi: this.ekBilgiler.programIsmi },
            guncelSure: this.guncelSure,
            toplamSure: this.toplamSure,
            x: this.x,
            y: this.y,
            z: this.z,
        }

        return _rslt;
    }

    // static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
    //     const _rslt = new FikoVektorTakimYol3D(json.x, json.y, json.z);

    //     _rslt.takimYonu.fromArray(json.takimYonu);
    //     _rslt.hiz = json.hiz;
    //     _rslt.devir = json.devir;
    //     _rslt.renk = new THREE.Color().fromArray(json.renk);
    //     // _rslt.takim = new FikoTakimFrezeleme(sahne,);
    //     _rslt.ekBilgiler = { ismi: json.ekBilgiler.ismi, programIsmi: json.ekBilgiler.programIsmi },
    //         _rslt.guncelSure = json.guncelSure;
    //     _rslt.toplamSure = json.toplamSure;

    //     return _rslt;
    // }

}